import formatPrice from './format-price';
import getProductPrice from './get-product-price';
import makeProductsList from './make-products-list';
import makeTldList from './make-tld-list';
import paymentUrl from './payment-url';
import getPriceParts from './get-price-parts';

const actions = {
  makeTldList: makeTldList,
  formatPrice: formatPrice,
  getProductPrice: getProductPrice,
  makePaymentUrl: paymentUrl.regular,
  makePaymentUrlWL: paymentUrl.whitelabel,
  makePaymentUrlWLAddon: paymentUrl.whitelabelAddon,
  makeProductsList: makeProductsList,
  getPriceParts: getPriceParts,
};

export default actions;
